import React, { createRef } from 'react'
import { object, func } from 'prop-types'
import fetch from 'isomorphic-fetch'
import { withContext } from '../../../utils/withContext'
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements'

import styles from './PaymentForm.styl'
import PaymentOptions from '../PaymentOptions/PaymentOptions'
import PaymentTypeInput from '../PaymentTypeInput/PaymentTypeInput'
import CountrySelectInput from '../CountrySelectInput/CountrySelectInput'
import Loading from '../Loading/Loading'

const cardInputStyle = {
	base: {
		fontSize: '15px',
		fontFamily: '"Montserrat"'
	}
}

class PaymentForm extends React.Component {

	static propTypes = {
		stripe: object,
		athlete: object,
		plan: object,
		context: object,
		handleNext: func
	}

	constructor(props) {
		super(props)
		const { athlete: { name, bilingAddress, taxpayerNumber } } = props
		this.paymentForm = createRef()
		this.state = {
			paymentType: 'monthly',
			paymentMethod: 'card',
			name,
			bilingAddress,
			cardOwner: '',
			taxpayerNumber,
			changed: {
				cardNumber: false,
				cardCVC: false,
				cardDate: false
			},
			error: {
				cardNumber: true,
				cardCVC: true,
				cardDate: true
			}
		}
	}

	handleCardInputChange(key, value) {
		const { error, changed } = this.state
		this.setState({ error: { ...error, [key]: value }, changed: { ...changed, [key]: true } })
	}

	renderCardForm() {
		const { cardOwner, error, changed } = this.state
		const { context: { i18n } } = this.props
		return (
			<div className={ styles['card-form'] }>
				<h2>{ i18n`payment_information_label` }</h2>
				<div className={ `${ styles['card-form-input'] } ${ error['cardOwner'] ? styles['error'] : '' }` }>
					<label>{ i18n`card_owner_label` }</label>
					<input type="text" placeholder="Quim Barreiros" value={ cardOwner } onChange={ (e) => { this.setState({ cardOwner: e.target.value }) } } />
				</div>
				<div className={ `${ styles['card-form-input'] } ${ error['cardNumber'] && changed['cardNumber'] ? styles['error'] : '' }` }>
					<label>{ i18n`card_number_label` }</label>
					<CardNumberElement onChange={ (cardNumberState) => { this.handleCardInputChange('cardNumber', !cardNumberState.complete) } } style={ cardInputStyle } />
				</div>
				<div className={ styles['double-input-row'] }>
					<div className={ `${ styles['card-form-input'] } ${ error['cardDate'] && changed['cardDate'] ? styles['error'] : '' }` }>
						<label>{ i18n`expiration_date_label` }</label>
						<CardExpiryElement style={ cardInputStyle } onChange={ (cardCVCState) => { this.handleCardInputChange('cardDate', !cardCVCState.complete) } } />
					</div>
					<div className={ `${ styles['card-form-input'] } ${ error['cardCVC'] && changed['cardCVC'] ? styles['error'] : '' }` }>
						<label>{ i18n`card_cvc_label` }</label>
						<CardCVCElement style={ cardInputStyle } onChange={ (cardDateState) => { this.handleCardInputChange('cardCVC', !cardDateState.complete) } } />
					</div>
				</div>
			</div>
		)
	}

	renderUserForm() {
		const { name, bilingAddress, taxpayerNumber } = this.state
		const { context: { i18n } } = this.props
		const { street, city, postalCode, country } = (bilingAddress || {})
		return (
			<div className={ styles['user-form'] }>
				<h2>{ i18n`billing_information_label` }</h2>
				<div className={ styles['user-form-input'] }>
					<label>{ i18n`name_label` }</label>
					<input type="text" placeholder="Quim Barreiros" value={ name } onChange={ (e) => { this.setState({ name: e.target.value }) } } />
				</div>
				<div className={ styles['user-form-input'] }>
					<label>{ i18n`registry_nif_label` }</label>
					<input type="text" placeholder="Quim Barreiros" value={ taxpayerNumber } onChange={ (e) => { this.setState({ taxpayerNumber: e.target.value }) } } />
				</div>
				<div className={ styles['user-form-input'] }>
					<label>{ i18n`registry_address_label` }</label>
					<input type="text" placeholder="Quim Barreiros" value={ street } onChange={ ({ target }) => { this.setState(prevState => ({ bilingAddress: { ...prevState.bilingAddress, street: target.value } })) } } />
				</div>
				<div className={ styles['double-input-row'] }>
					<div className={ styles['user-form-input'] }>
						<label>{ i18n`registry_city_label` }</label>
						<input type="text" placeholder="Quim Barreiros" value={ city } onChange={ ({ target }) => { this.setState(prevState => ({ bilingAddress: { ...prevState.bilingAddress, city: target.value } })) } } />
					</div>
					<div className={ styles['user-form-input'] }>
						<label>{ i18n`registry_postal_code_label` }</label>
						<input type="text" placeholder="Quim Barreiros" value={ postalCode } onChange={ ({ target }) => { this.setState(prevState => ({ bilingAddress: { ...prevState.bilingAddress, postalCode: target.value } })) } } />
					</div>
				</div>
				<div className={ styles['user-form-input'] }>
					<label>{ i18n`registry_country_label` }</label>
					<CountrySelectInput
						className={ styles['country-select-input'] }
						value={ country }
						onChange={ ({ target }) => { this.setState(prevState => ({ bilingAddress: { ...prevState.bilingAddress, country: target.value } })) } }
					/>
				</div>
			</div>
		)
	}

	handleError(obj) {
		const error = {}
		Object.entries(obj).forEach(([key, value]) => {
			error[key] = !value
		})
		return error
	}

	handleSubmit() {
		const { handleNext } = this.props
		const { error } = this.state
		const { paymentType,
			paymentMethod,
			name,
			bilingAddress,
			cardOwner,
			taxpayerNumber
		} = this.state

		const newError = this.handleError({
			paymentType,
			paymentMethod,
			name,
			...bilingAddress,
			taxpayerNumber
		})
		if (Object.values(newError).some(f => f)) {
			this.setState({
				error: { ...error, ...newError }
			})
			return
		}
		if (paymentMethod === 'card' && Object.values({ ...error, ...newError, cardOwner: !cardOwner }).some(f => f)) {
			this.setState({
				error: {
					...error, ...newError, cardOwner: !cardOwner
				},
				changed: {
					cardNumber: true,
					cardCVC: true,
					cardDate: true
				}
			})
			return
		}
		handleNext({
			paymentType,
			paymentMethod,
			name,
			bilingAddress,
			cardOwner,
			taxpayerNumber
		})
	}

	render() {
		const { paymentMethod, multibanco, paymentType, error: { error, message } } = this.state
		const { context: { i18n } } = this.props
		const insideForm = (
			<div className={ styles['inside-form-container'] }>
				{ !multibanco ? this.renderUserForm() : null }
				{ paymentMethod === 'card' ? this.renderCardForm() : null }
			</div>
		)
		return (
			<div>
				<div className={ styles['content'] }>
					<div className={ styles['payment-form'] }>
						<h2>{ i18n`payment_label` }</h2>
						<div className={ styles['payment-methods-container'] }>
							<PaymentOptions value={ paymentMethod } onChange={ value => { this.setState({ paymentMethod: value }) } } />
						</div>
						<div className={ styles['payment-type-container'] }>
							<PaymentTypeInput value={ paymentType } onChange={ value => { this.setState({ paymentType: value }) } } />
						</div>
						{ error ? <h2 className={ styles['error-message'] }>{ message }</h2> : null }
						{ insideForm }
						<button className={ styles['payment-button'] } onClick={ this.handleSubmit.bind(this) }>{ i18n`next_label` }</button>
					</div>
				</div>
			</div >
		)
	}
}

export default withContext(injectStripe(PaymentForm))



// WEBPACK FOOTER //
// ./src/client/webapp/components/PaymentForm/PaymentForm.js